import { BrowserRouter, Switch, Route } from "react-router-dom";
import Index from "./component/home/index";
import { Provider } from "react-redux";
import "./assets/css/index.css";
import "./assets/fonts/ubuntu.css";
import store from "./redux/store/store";
import Collection from "./component/my_profile/Collection";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route path="/dashboard" component={Collection}></Route>
            <Route path="/" component={Index}></Route>
          </Switch>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
